export default __webpack_public_path__ + "static/media/pic107.f6d57166.jpg";